import { getUserID, token } from "constant/localStorage";

const API_URL = process.env.REACT_APP_API_URL;

export async function batch() {
  try {
    const response = await fetch(
      `${API_URL}/batchings?limit=0&page=0&filter=&exclude_expired=false`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token()}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function detailBatch(
  id,
  minValue = "", 
	maxValue = "", 
  minMaturity = "",
  maxMaturity = "",
  minFinancing = "",
  maxFinancing = ""
) {
  try {
    const response = await fetch(
      `${API_URL}/batchings/${id}?exclude_expired=false&min_value=${ minValue }&max_value=${ maxValue }&limit=0&page=0&filter=&min_remaining_maturity=${ minMaturity }&max_remaining_maturity=${ maxMaturity }&min_financing_limit=${ minFinancing }&max_financing_limit=${ maxFinancing }`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token()}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function createBatch(registrationId, batchingData) {
  try {
    const response = await fetch(`${API_URL}/batchings`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token()}`,
      },
      body: JSON.stringify({
        registration_id: registrationId,
        batching_data: batchingData,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function deleteBatch(id) {
  try {
    const response = await fetch(`${API_URL}/batchings/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token()}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function updateBatch(registrationId, batchingData, id) {
  try {
    const response = await fetch(`${API_URL}/batchings/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token()}`,
      },
      body: JSON.stringify({
        registration_id: registrationId,
        batching_data: batchingData,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function getListPool() {
  try {
    const response = await fetch(
      `${API_URL}/poolings?sort_by=updated_at&order_by=desc`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token()}`,
        },
      }
    );

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function createPool(
  registrationId,
  company_id,
  pool_id,
  pool_value,
  oc_value,
  indicative_return,
  pooling_data,
  original_funding_amount
) {
  try {
    const response = await fetch(`${API_URL}/poolings`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token()}`,
      },
      body: JSON.stringify({
        owner_id: registrationId,
        company_id,
        batch_id: pool_id,
        // owner_id: getUserID(),
        status: "new",
        pooling_data,
        pool_value,
        oc_value,
        indicative_return,
        original_funding_amount
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function detailPool(id) {
  try {
    const response = await fetch(`${API_URL}/poolings/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token()}`,
      },
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function updatePool(pool) {
  try {
    const response = await fetch(`${API_URL}/poolings/${pool.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token()}`,
      },
      body: JSON.stringify({ ...pool }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function createMaturityPool(maturity) {
  try {
    const response = await fetch(`${API_URL}/pool-maturity-histories`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token()}`,
      },
      body: JSON.stringify({ ...maturity }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}

export async function updateMaturityPool(maturity) {
  try {
    const response = await fetch(`${API_URL}/pool-maturity-histories/${maturity.id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token()}`,
      },
      body: JSON.stringify({ ...maturity }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      if (errorData.code === 401 && errorData.code_type === "unAuthorized") {
        window.location.href = "/login";
      } else {
        throw errorData.code_message;
      }
    }
    const data = await response.json();
    return data;
  } catch (error) {
    throw error;
  }
}
